import React, { useState, useEffect } from 'react'
import { Input, ColorPicker, Upload } from 'antd'
import styles from '../../../styles/product.module.scss'

const CustomTag = ({
  tagId,
  tagText,
  tagBackgroundColor,
  tagTextColor,
  tagIconUrl,
  onTagChange,
  onImageChange,
  onDelete,
}) => {
  // 로컬 미리보기 상태 추가
  const [localIconPreview, setLocalIconPreview] = useState('')
  const [isSvgFile, setIsSvgFile] = useState(false)
  const [svgContent, setSvgContent] = useState('')

  // SVG 파일인지 판단하는 함수
  const checkIfSvg = (url) => {
    if (typeof url === 'string') {
      return url.toLowerCase().endsWith('.svg')
    } else if (url && typeof url === 'object' && url.name) {
      return url.name.toLowerCase().endsWith('.svg')
    }
    return false
  }

  // SVG 파일 내용을 읽어서 SVG 태그로 변환하는 함수
  const loadSvgContent = async (url) => {
    try {
      const response = await fetch(url)
      const svgText = await response.text()
      setSvgContent(svgText)
    } catch (error) {
      console.error('SVG 로드 실패:', error)
      setSvgContent('')
    }
  }

  // tagIconUrl이 변경될 때마다 로컬 미리보기 업데이트
  useEffect(() => {
    if (
      tagIconUrl &&
      typeof tagIconUrl === 'string' &&
      tagIconUrl.trim() !== ''
    ) {
      // 문자열 URL인 경우 (조회 시 기존 이미지)
      setLocalIconPreview(tagIconUrl)
      const isSvg = checkIfSvg(tagIconUrl)
      setIsSvgFile(isSvg)
      if (isSvg) {
        loadSvgContent(tagIconUrl)
      } else {
        setSvgContent('')
      }
    } else if (tagIconUrl && typeof tagIconUrl === 'object' && tagIconUrl.url) {
      // 객체인 경우 (새로 업로드된 이미지)
      setLocalIconPreview(tagIconUrl.url)
      const isSvg = checkIfSvg(tagIconUrl)
      setIsSvgFile(isSvg)
      if (isSvg) {
        loadSvgContent(tagIconUrl.url)
      } else {
        setSvgContent('')
      }
    } else {
      // 이미지가 없는 경우
      setLocalIconPreview('')
      setIsSvgFile(false)
      setSvgContent('')
    }
  }, [tagIconUrl])

  const handleChange = (e) => {
    onTagChange?.(e.target.name, e.target.value)
  }

  const handleImageChange = (file, fileList, event, type) => {
    console.log('handleImageChange 호출:', { file, fileList, event, type })

    // 로컬 미리보기 즉시 업데이트
    if (type === 'tagIconUrl' && file && !file.status) {
      const previewUrl = URL.createObjectURL(file)
      setLocalIconPreview(previewUrl)
    }

    onImageChange?.(file, fileList, event, type)
  }

  const handlePreview = (file) => {
    // 미리보기 로직은 부모 컴포넌트에서 처리
    console.log('미리보기 요청:', file)
  }

  return (
    <div className={`${styles['product-register-custom-tag-wrap']}`}>
      <div className={styles['custom-tag-container']}>
        <Input
          className={`${styles['product-exposure-tag-input']}`}
          name="text"
          value={tagText ?? ''}
          onChange={handleChange}
          placeholder="태그"
          style={{ marginBottom: '4px' }}
        />

        <div className={styles['color-picker-group']}>
          <ColorPicker
            disabled={!tagText || tagText.trim().length === 0}
            value={tagBackgroundColor ?? '#FFFFFF'}
            onChange={(color) => {
              handleChange({
                target: {
                  name: 'backgroundColor',
                  value: color.toHexString(),
                },
              })
            }}
            style={{ width: '100%' }}
          >
            <Input
              className={`${styles['product-exposure-tag-input']}`}
              placeholder="태그 배경 색상"
              value={tagBackgroundColor ?? ''}
              disabled={!tagText || tagText.trim().length === 0}
            />
          </ColorPicker>
        </div>

        <div className={styles['color-picker-group']}>
          <ColorPicker
            disabled={!tagText || tagText.trim().length === 0}
            value={tagTextColor ?? '#000000'}
            onChange={(color) => {
              handleChange({
                target: {
                  name: 'textColor',
                  value: color.toHexString(),
                },
              })
            }}
            style={{ width: '100%' }}
          >
            <Input
              className={`${styles['product-exposure-tag-input']}`}
              placeholder="태그 폰트 색상"
              value={tagTextColor ?? ''}
              disabled={!tagText || tagText.trim().length === 0}
            />
          </ColorPicker>
        </div>

        <div className={styles['upload-container']}>
          <Upload
            className={styles.myTinyUpload}
            listType="text"
            maxCount={1}
            fileList={
              tagIconUrl &&
              ((typeof tagIconUrl === 'object' &&
                Object.keys(tagIconUrl)?.length !== 0) ||
                (typeof tagIconUrl === 'string' && tagIconUrl.trim() !== ''))
                ? [tagIconUrl]
                : null
            }
            onChange={({ file, fileList, event }) =>
              handleImageChange(file, fileList, event, 'tagIconUrl')
            }
            onPreview={handlePreview}
            beforeUpload={(file) => {
              return new Promise((resolve) => {
                // 업로드한 파일이 이미지 형식인지 확인
                const isImg =
                  file.type === 'image/jpeg' ||
                  file.type === 'image/jpg' ||
                  file.type === 'image/png' ||
                  file.type === 'image/gif' ||
                  file.type === 'image/webp' ||
                  file.type === 'image/svg+xml'
                if (!isImg) {
                  alert(
                    '이미지 파일(webp, jpeg, jpg, png, gif, svg)만 업로드 되어야 합니다.',
                  )
                  return Upload.LIST_IGNORE
                }
                // 이미지 크기 제한 제거 - 모든 크기 허용
                return resolve(false)
              })
            }}
          >
            {tagIconUrl &&
            ((typeof tagIconUrl === 'object' &&
              Object.keys(tagIconUrl)?.length !== 0) ||
              (typeof tagIconUrl === 'string' &&
                tagIconUrl.trim() !== '')) ? null : (
              <div className={styles['upload-icon-wrap']}>
                <div className={styles['upload-button']}>사진 추가</div>
              </div>
            )}
          </Upload>
        </div>

        {/* 미리보기와 삭제 버튼 */}
        {tagText && tagBackgroundColor && tagTextColor && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div
              className={styles['tag-preview']}
              style={{
                backgroundColor: tagBackgroundColor ?? '#FFF',
                color: tagTextColor ?? '#000',
              }}
            >
              {/* 아이콘이 있으면 맨 앞에 표시 - SVG와 일반 이미지 분기 처리 */}
              {localIconPreview &&
                (isSvgFile && svgContent ? (
                  // SVG 파일인 경우 SVG 태그로 직접 렌더링
                  <div
                    className={styles['tag-preview-icon']}
                    style={{
                      width: '16px',
                      height: '16px',
                      marginRight: '4px',
                      verticalAlign: 'middle',
                      display: 'inline-block',
                    }}
                    dangerouslySetInnerHTML={{ __html: svgContent }}
                  />
                ) : (
                  // 일반 이미지 파일인 경우 img 태그로 처리
                  <img
                    src={localIconPreview}
                    alt="태그 아이콘"
                    className={styles['tag-preview-icon']}
                    style={{
                      width: '16px',
                      height: '16px',
                      marginRight: '4px',
                      verticalAlign: 'middle',
                      display: 'inline-block',
                    }}
                    onError={(e) => {
                      console.log('이미지 로드 실패:', e.target.src)
                      e.target.style.display = 'none'
                    }}
                  />
                ))}
              <span
                style={{ verticalAlign: 'middle', display: 'inline-block' }}
              >
                {tagText}
              </span>
            </div>

            {/* 삭제 버튼 */}
            {tagId && (
              <button
                type="button"
                onClick={() => onDelete?.(tagId)}
                style={{
                  padding: '2px 6px',
                  fontSize: '10px',
                  backgroundColor: '#ff4d4f',
                  color: 'white',
                  border: 'none',
                  borderRadius: '3px',
                  cursor: 'pointer',
                  flexShrink: 0,
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#ff7875'
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#ff4d4f'
                }}
              >
                삭제
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomTag
